import listModules from './utils/listModules';
import Axios from 'utils/axios';

export default listModules({
    actions: {
        fetch: '/admin/company/list',
        fetchOne({ commit, state }, { id }) {
            return Axios.post('/admin/company/detail', {
                id
            });
        },
        create({ commit, dispatch, state }, payload) {
            return Axios.post('/admin/company/add', payload);
        },
        update({ commit, dispatch, state }, payload) {
            return Axios.post('/admin/company/update', payload);
        },
        delete({ commit, dispatch, state }, { id }) {
            return Axios.post('/admin/company/del', { id });
        }
    }
});
